$.extend
  clear: (handle) ->
    window.clearTimeout(handle)

  delay: (ms, func) ->
    window.setTimeout(func, ms)

  repeat: (ms, func) ->
    window.setInterval(func, ms)

  getQS: (key) ->
    key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
    regex = new RegExp("[\\?&]" + key + "=([^&#]*)")
    results = regex.exec(location.search)
    if results
      return decodeURIComponent(results[1].replace(/\+/g, " "))
    return null

  sum: (l) ->
    l.reduce (a, b) ->
      a + b
    , 0

  randInt: (n) ->
    # Returns a random integer between 0 (included) and n (excluded)
    # Using Math.round() will give you a non-uniform distribution!
    return Math.floor(Math.random() * Math.floor(n))

  # shallow
  copy: (o) ->
    newObj = {}
    for k of o
      newObj[k] = o[k]
    return newObj

$(document).ready () ->

  $.browser =
    mobile: window.matchMedia("only screen and (max-device-width: 800px)").matches
    phone: window.matchMedia("only screen and (max-device-width: 640px)").matches
    # console.log('mobile: ' + $.browser.mobile)
    # console.log('phone: ' + $.browser.phone)

  ua = navigator.userAgent
  iOS = /iPad|iPhone|iPod/.test(ua)
  iOS11 = /OS 11_/.test(ua)
  recent_iOS = $.browser.mobile and iOS and iOS11

  $.ajaxSetup
    xhrFields: {
      withCredentials: true
    }
    beforeSend: (xhr, settings) ->
      xhr.setRequestHeader("AUTHORIZATION", 'c61de580-e48d-41d2-a8d1-6cd1429987a1')
      if not /^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type) and not @crossDomain
        # We need to re-fetch the cookie here every time just in case we have logged in the user without
        # a page refresh (as it happened when exp_22 came in. See: https://www.pivotaltracker.com/story/show/163027230)
        xhr.setRequestHeader("X-CSRFToken", $.cookie('csrftoken'))

  # if user is not logged in, show signup when trying to add
  $(document).on 'click', '.require-signup', (evt) ->
    evt.preventDefault()
    $target = $(evt.currentTarget)
    $target.addClass('auto-click')
    if recent_iOS
      $('body').css('position', 'fixed')

    # Redirect to signup then bring the customer back to the page they were on
    window.location.href = '/signup/?next=' + window.location.pathname
    
    return false

  # -------- Account Nav --------
  for el in $('.account-tabs a').get()
    # console.log(el, $(el).attr('href'))
    if $(el).attr('href').startsWith(window.location.pathname)
      $(el).addClass('active')
      break

  # -------- Banner --------

  # get the banners them show them and increase the dimension of the content-wrapper
  set_cw_padding = () ->
    # Setting up the content wrapper padding if there are banners
    if $('#nav-banners').children().length
      setTimeout () ->
        new_padding = $('.header-wrapper').height()
        $('#content-wrapper').css('padding-top', new_padding)
      , 0

  $('#nav-banners').each (i, el) ->
    observer = new MutationObserver(set_cw_padding)
    observer.observe(el, { childList: true, subtree: true })

  $('#nav-banners').children().each () ->
    $(this).show()

  set_cw_padding()

  $('#nav-banners .close').on 'click', () ->
    $(this).parent().hide()
    set_cw_padding()

  cookie_setter = (elementName, expiration_days) ->
    $.cookie elementName, 1,
    expires: expiration_days
    path: '/'

  closeBanner = (evt) ->
    elementCookieId = $(evt.target.closest('.top-banner')).attr('id')
    cookie_setter(elementCookieId, 9999)
    $('.top-banner').hide()
    set_cw_padding()

#  $('.top-banner a').on 'click', (evt) ->
#    closeBanner(evt)

  $('.top-banner .close').on 'click', (evt) ->
    closeBanner(evt)

  # -------- Login/Signup --------

  reloadPage = () ->
    next = $.getQS('next')
    if next
      window.location.href = next
    else
      location.reload()

  $login = $('#login-wrapper')

  check_bundle_redirect = () ->
    setTimeout ->
      if $('.auto-click').length
        $('.auto-click').trigger('click')
      else
        reloadPage()
    , 500

  $('a.login-button').add('.login-header-btn').on 'click', (evt) ->
    ga('send', 'event', 'login', 'open')
    $login.show()

  $login.find('.close').on 'click', (evt) ->
    ga('send', 'event', 'login', 'close')
    $login.find('.error').hide()
    $login.find('button[type="submit"]').prop('disabled', false)
    $login.find('.facebook-login').removeClass('disabled')
    $login.fadeOut()
    if recent_iOS
      $('body').css('position', 'static')

  $login.find('form').on 'submit', (evt) ->
    ga('send', 'event', 'login', 'submit')
    evt.preventDefault()
    options =
      email: $login.find('input[name="email"]').val()
      password: $login.find('input[name="password"]').val()

    $.ajax
      type: 'POST'
      url: "/api/login/"
      data: options
      success: (data) ->
        ga('send', 'event', 'login', 'success')
        $('.require-signup').removeClass('require-signup')
        $login.find('button[type="submit"]').prop('disabled', true).text('Loading...')
        $login.find('.facebook-login').addClass('disabled')

        if typeof (dataLayer.push) == "function"
          dataLayer.push
            'event': 'hr.login.success'
            'login':
              'method': 'email'
            'customer':
              'id': data.id
              'email': data.email

        check_bundle_redirect()
      error: (xhr, ajaxOptions, thrownError) ->
        ga('send', 'event', 'login', 'failure')
        $login.find('.login-error').show()
        $login.find('.dialog').effect('shake', {times: 3, displace: 10})
    return false

  # SIGNUP

  $('.pw-input').on 'focus', (evt) ->
    # TODO move these inline styles to stylus
    $('.pw-input').css('outline', 'none')
    $('.pw-input').css({'border': '2px solid #F73A44'})
    $('.show-pw-container').css({'border': '2px solid #F73A44', 'border-left': 'none'})
  $('.pw-input').on 'focusout', (evt) ->
    $('.show-pw-container, .pw-input').css('border', '1px solid #A5A5A5')

  $('.signup-header-btn-ajax').on 'click', (evt) ->
    # Signup button in mobile views (except in get_started_view(s),
    # because that one is just a link to the /signup/ page)
    $('#signup-wrapper').show()
    ga('send', 'event', 'signup', 'open')
    dataLayer.push
      'event': 'hr.signup.open'

  # Auto show
  if $('#show_login').length
    $login.show()

  #----------- mobile --------------
  $menu = $('#mobile-menu')

  if $menu.is(':visible')
    $("header-wrapper").hide()

  $('.menu-icon').on 'click', (evt) ->
    $('body').addClass('prevent-scroll')
    $menu.slideDown()

  $menu.find('.close-icon').on 'click', (evt) ->
    $menu.slideUp()
    $('body').removeClass('prevent-scroll')

  $menu.find('.login').on 'click', (evt) ->
    ga('send', 'event', 'login', 'open')
    $login.show()
    if recent_iOS
      $('body').css('position', 'fixed')

  $('#mobile-footer .top').on 'click', (evt) ->
    $('body').animate
      scrollTop: 0

  #ACCOUNT DRODOWN MENU event listeners for touchscreen devices:

  touchscreen_cb = (evt) ->
    #show the menu
    if $(".hr-dropdown-menu").is(":visible")
      $(".hr-dropdown-menu").hide()
    else
      $(".hr-dropdown-menu").show()

  $('.hr-dropdown-header').on "click", touchscreen_cb

  # For accessiblity listen to "Tab" key events
  $(window).on 'keydown', (evt) ->
    if evt.key == 'Tab'
      # close menu if it needs to be closed.
      close_menu = (evt) ->
        setTimeout () =>
          current_target = document.activeElement
          if current_target not in $('.hr-dropdown-menu a')
            $(".hr-dropdown-menu").css('display', 'none')
        , 0

      $(".hr-dropdown-header").on "focus", (evt) ->
        $(".hr-dropdown-menu").css('display', 'inline-flex')

      $('.hr-dropdown-menu a').on "focusout", close_menu

      # if using the mouse aferwards making sure to be able to open and close the menu:
      $(document).on 'click', (evt) ->
        if evt.target != $('.hr-dropdown-header')[0] and $(".hr-dropdown-menu").is(":visible") and evt.target not in $('.hr-dropdown-menu a')
          $(".hr-dropdown-menu").css('display', 'none')


  # collapsible components
  # sets plus and minuses for all collapsible headers
  collapsible_headers = $('.hr-collapsible-header')
  if collapsible_headers.length
    collapsible_headers.append('<div class="hr-collapsible-plus">+</div>')
    collapsible_headers.append('<div class="hr-collapsible-minus">-</div>')

  $('.hr-collapsible-plus').on 'click', () ->
    content = $(this).parent().parent().find('.hr-collapsible-content')
    content.animate({ maxHeight: 400, marginBottom: 10 }, 150)
    $(this).hide()
    $(this).next().show()

  $('.hr-collapsible-minus').on 'click', () ->
    content = $(this).parent().parent().find('.hr-collapsible-content')
    content.animate({ maxHeight: 0, marginBottom: 0 }, 150)
    $(this).hide()
    $(this).prev().show()

  # UNHOLD REACTIVATE BANNERS

  unhold_customer = () ->
    # GETing the /cancel/unhold view will kick the customer outside of a HELD status
    ga('send', 'event', 'cancel', 'unhold')
    window.location = '/cancel/unhold/?source=banner'

  reactivate_customer = () ->
    ga('send', 'event', 'cancel', 'reactivate_confirm')
    window.location = '/cancel/reactivate/confirm/'

  $('.on-hold-resume-btn').on 'click', (evt, data) ->
    unhold_customer()

  reactivate_disabled = false
  $('.reactivate-link > .hr-cancel-btn').on 'click', (evt, data) ->
    if reactivate_disabled
      return
    else
      reactivate_disabled = true
      reactivate_customer()
